
define('lib/require.text!../templates/manual.html',[],function () { return '<h1>Baseball GM Manual</h1>\n\n<div id="manual-content"></div>';});

